import { useState } from "react";
import { SelectPicker } from "rsuite";
import { RelatedRecord } from "../../../types/GlobalInterfaces";
import { Module } from "../../../types/TenantInterfaces";
import ReferenceCreate from "../../../components/Records/References/ReferenceCreate";
import pluralize from "pluralize";
import useModule from "../../../hooks/useModule";

interface RelatedRecordsDrawerBodyInterface {
  remainingModuleOptions: Module[];
  setExistingRelatedRecord: any;
  existingRelatedRecord?: RelatedRecord;
}

interface RecordSelectPickerInterface {
  setExistingRelatedRecord: any;
  existingRelatedRecord?: RelatedRecord;
  selectedModule: string;
}

const RecordSelectPicker = ({
  selectedModule,
  existingRelatedRecord,
  setExistingRelatedRecord,
}: RecordSelectPickerInterface) => {
  const { module } = useModule(selectedModule);

  const handleSelectRecord = (
    selectedReferenceID: string | null,
    recordName: string
  ) => {
    if (!selectedReferenceID) return;

    setExistingRelatedRecord({
      _ModuleAPIName: selectedModule,
      id: selectedReferenceID,
      _id: selectedReferenceID,
      _RecordName: recordName,
      Value: `{{cloud.${selectedModule}}}`,
    });
  };

  const moduleName = pluralize.singular(module?.Name || "");

  return (
    <>
      <hr />
      <h5 className="mb-0">Select {moduleName}</h5>
      <div className="small mb-3">
        Select the default {moduleName} for this cloud
      </div>
      <ReferenceCreate
        //@ts-ignore
        field={{
          FieldType: "SingleReference",
          SourcesList: `Tenant.Modules.${selectedModule}`,
        }}
        value={existingRelatedRecord}
        onChange={(f: any) => {
          handleSelectRecord(f._id, f._RecordName);
        }}
      />
    </>
  );
};

const RelatedRecordsDrawerBody = ({
  existingRelatedRecord,
  setExistingRelatedRecord,
  remainingModuleOptions,
}: RelatedRecordsDrawerBodyInterface) => {
  const [selectedModule, setSelectedModule] = useState<string | undefined>(
    existingRelatedRecord ? existingRelatedRecord._ModuleAPIName : undefined
  );

  return (
    <div>
      <h5>Data Source</h5>
      <SelectPicker
        data={remainingModuleOptions}
        placeholder="Select Data Source"
        labelKey="Name"
        valueKey="APIName"
        value={selectedModule}
        searchable={remainingModuleOptions.length > 5}
        cleanable={!!selectedModule}
        onChange={(moduleAPIName: string | null) =>
          setSelectedModule(moduleAPIName || undefined)
        }
        className="w-100"
      />
      {!!selectedModule && (
        <RecordSelectPicker
          selectedModule={selectedModule}
          existingRelatedRecord={existingRelatedRecord}
          setExistingRelatedRecord={setExistingRelatedRecord}
        />
      )}
    </div>
  );
};

export default RelatedRecordsDrawerBody;
